import { useState, useEffect } from 'react';

export const useScrollPosition = (): number => {
  const [position, setPosition] = useState(window.scrollY);

  const onScroll = () => {
    setPosition(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    window.scrollTo({ top: 0 });
    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  return position;
};
